export function buildGraphData(payload) {
  if (!payload?.nodes?.length) {
    return { nodes: [], links: [] }
  }

  const nodes = payload.nodes.map((node) => ({
    ...node,
    id: node.id,
    name: node.label,
    connectionCount: 0,
  }))

  const nodeById = new Map(nodes.map((node) => [node.id, node]))

  const links = payload.edges.map((edge) => {
    const source = edge.source
    const target = edge.target

    if (nodeById.has(source)) nodeById.get(source).connectionCount += 1
    if (nodeById.has(target)) nodeById.get(target).connectionCount += 1

    return {
      ...edge,
      source,
      target,
    }
  })

  return { nodes, links }
}

export function buildAdjacency(links) {
  const adjacency = new Map()

  const addNeighbor = (from, to) => {
    if (!adjacency.has(from)) adjacency.set(from, new Set())
    adjacency.get(from).add(to)
  }

  links.forEach((link) => {
    addNeighbor(link.source, link.target)
    addNeighbor(link.target, link.source)
  })

  return adjacency
}

export function sortNodesForRender(nodes, centerId) {
  if (centerId == null) return nodes

  const center = nodes.find((node) => node.id === centerId)
  if (!center) return nodes

  return [...nodes.filter((node) => node.id !== centerId), center]
}

export function neighborsForNode(nodeId, adjacency) {
  return Array.from(adjacency.get(nodeId) ?? []).sort((a, b) => a - b)
}
